import { useLocation, useNavigate } from "react-router-dom";
import pointerEvents from "../utils/pointerEvents";
import TextArrow from "../Arrow/TextArrow";

export default function RouteToggle() {
  const navigate = useNavigate();
  const location = useLocation();

  const isProjectsRoute = location.pathname === "/projects";
  const targetPath = isProjectsRoute ? "/" : "/projects";
  const buttonLabel = isProjectsRoute ? "Back To Main" : "Go To Projects";

  return (
    <>
      <TextArrow
        {...pointerEvents}
        onClick={(event) => {
          event.stopPropagation();
          navigate(targetPath);
        }}
        position={[0, -0.9, 2.5]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={1}
      >
        {buttonLabel}
      </TextArrow>
    </>
  );
}
